import bindAllMethods from '../../../utils/bindAllMethods';
import { getServices } from '../../../infra/startup';
import { GraphQLInterfaceV1Type } from '@clientos/types';
import IGraphQLService from '../../../services/graphQLService/IGraphQLService';
import {
  ClientFetchResult,
  ClientQueryResult
} from '@clientos/graphql-client/dist/services/GraphQLService/types';
import ITenantHandlerService from '../../../services/tenantHandler/ITenantHandlerService';

class GraphQLInterfaceV1 {
  private _graphQLService: IGraphQLService;
  private _tenantHandlerService: ITenantHandlerService;

  constructor() {
    const { graphQLService, tenantHandlerService } = getServices();
    this._graphQLService = graphQLService;
    this._tenantHandlerService = tenantHandlerService;
    bindAllMethods(this);
  }

  public getInterface(): GraphQLInterfaceV1Type {
    const { gql, getClient, getReactTools } = this._graphQLService;
    const { createGraphQLProvider, useQuery, useMutation, useLazyQuery } =
      getReactTools() || {};

    return {
      gql,
      query: this.query,
      mutate: this.mutate,
      getClient,
      reactTools: { createGraphQLProvider, useQuery, useMutation, useLazyQuery }
    };
  }

  private async query<TData, TVariables>(
    query: string,
    variables?: TVariables
  ): Promise<ClientQueryResult<TData>> {
    if (typeof query !== 'string') {
      throw new Error('Query must be a string!');
    }
    const { getClient } = this._graphQLService;
    const client = getClient();

    const options = { tenantId: this._tenantHandlerService.getTenantId() };

    return client.query(query, variables, options);
  }

  private async mutate<TData, TVariables>(
    mutation: string,
    variables?: TVariables
  ): Promise<ClientFetchResult<TData>> {
    if (typeof mutation !== 'string') {
      throw new Error('Mutation must be a string!');
    }
    const { getClient } = this._graphQLService;
    const client = getClient();

    const options = { tenantId: this._tenantHandlerService.getTenantId() };

    return client.mutate(mutation, variables, options);
  }
}

export default GraphQLInterfaceV1;
